import { ClientAction } from '@entities/clients';
import Modal from 'react-modal';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '@shared/hooks';
import { MediumHeader } from '@shared/ui';
import { closeActionModal, closeAddModal } from '@src/library/redux/modal';
import * as st from './styles.module.scss';

export function AddClientsModal() {
  const dispatch = useDispatch();
  const onClose = () => dispatch(closeAddModal());
  const data = useAppSelector((state) => state.modals.isAddProps);
  const actions = [
    {
      title: data.newText,
      action: () => {
        data.newAction();
        onClose();
      },
    },
    {
      title: data.haveText,
      action: () => {
        data.haveAction();
        onClose();
      },
    },
  ];

  return (
    <Modal isOpen onRequestClose={onClose} className={st.modal} overlayClassName={st.overlay}>
      <MediumHeader title="Добавление клиента" onClose={onClose} />
      <div className={st.list}>
        {actions.map((action, index) => (
          <ClientAction key={index} onClick={action.action} title={action.title} />
        ))}
      </div>
    </Modal>
  );
}
